import { gql } from 'graphql-tag'
import { fragmentGlobalDataTheme } from '../../global-data/fragments'
import { fragmentModuleMedia, fragmentModuleNavigationLink } from '../../modules/fragments'

export default gql`
  ${fragmentGlobalDataTheme}
  ${fragmentModuleMedia}
  ${fragmentModuleNavigationLink}
  fragment BlockLandingMediaAndTextFragment on BlockLandingMediaAndText {
    sys {
      id
    }
    title
    blockLandingMediaAndTextDescription: description {
      json
    }
    mediaPosition: orientation
    mediaAspectRatio: mediaAspectRatio
    media {
      ... on ModuleMedia {
        ...ModuleMediaFragment
      }
    }
    link {
      ...ModuleNavigationLinkFragment
    }
    sectionTheme {
      ...GlobalDataThemeFragment
    }
  }
`
